import { render, staticRenderFns } from "./NewShop.vue?vue&type=template&id=142cb86c&scoped=true&"
import script from "./NewShop.vue?vue&type=script&lang=js&"
export * from "./NewShop.vue?vue&type=script&lang=js&"
import style0 from "./NewShop.vue?vue&type=style&index=0&id=142cb86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142cb86c",
  null
  
)

export default component.exports